import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=8f499a12&lang=pug&"
import script from "./ImageViewer.vue?vue&type=script&lang=ts&"
export * from "./ImageViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports